import { TFunction } from 'i18next';

export const truncateAddress = (address: string) => {
  return `${address.slice(0, 7)}...${address.slice(address.length - 5)}`;
};

export const DEBOUNCED_PHONE_AUTOCOMPLETED = 1200;

export const translateField = (
  t: TFunction,
  fieldName: string = '',
  options: {
    subKey?: 'field_name' | 'help_text' | 'description';
    by?: 'key' | 'section-name';
    isCustom?: boolean;
    isTransactionsReferenceDocumentType?: boolean;
  } = {}
) => {
  if (options.isCustom) return fieldName;

  if (options.isTransactionsReferenceDocumentType)
    return t(`template-select.${fieldName.toLowerCase().replaceAll(' ', '-')}`);

  const by = options.by ?? 'key';
  const baseKey = `template-fields.by-${by}.${fieldName
    .toLowerCase()
    .replaceAll(' ', '-')}`;

  return t(options?.subKey ? `${baseKey}.${options.subKey}` : baseKey);
};

export const translateFormSelect = (t: TFunction, selectLabel: string = '') => {
  const key = `template-select.${selectLabel
    .toLowerCase()
    .replaceAll(' ', '-')}`;
  const translation = t(key);
  return translation === key ? selectLabel : translation;
};

export const capitalize = (str: string) =>
  str ? str.charAt(0).toUpperCase() + str.slice(1).toLowerCase() : '';
